<template>
  <div class="amaze-select-then-other-input-component amaze-select-then-other-input">

    <v-select :items="items" v-model="item" required :rules="rules.required" v-on:change="dataChanged" @input="dataChanged">
      <template slot="label">
        <slot name="label">Select one of the options</slot><span v-if="required" class='star'>*</span>
      </template>
    </v-select>

    <v-text-field v-if="conditionMet" v-model="other" :required="conditionMet"
      :rules="conditionMet ? rules.required : []" v-on:change="dataChanged" @input="dataChanged">
      <template slot="label">
        <slot name="labelOther">Please specify the option</slot><span v-if="required" class='star'>*</span>
        </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  props: [
    "items", "required", "condition"
  ],
  computed: {
    conditionMet() {
      return this.item === (this.condition ? this.condition : 'Other');
    }
  },
  data() {
    return {
      item: null,
      other: null,
      "rules": {
        required: [v => !!v || "This information is required."]
      }
    };
  },
  methods: {
    dataChanged() {
      if (this.item) {
        this.$emit('input', this.item + (this.other && this.conditionMet ? ' - ' + this.other : ''));
        this.$emit('selected', this.item + (this.other && this.conditionMet ? ' - ' + this.other : ''));
      }
    }
  }
};
</script>
